import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import {
    ConfigurationIntermediateShelfSampleProcessAssignmentCreateRequest,
    ConfigurationIntermediateShelfSampleProcessAssignmentPatchInBatchRequest,
    ConfigurationIntermediateShelfSampleProcessAssignmentResponse
} from '@/modules/configurationModule/detail/automation/grossing-shelf/intermediate-shelf-process/services/configuration-intermediate-shelf-sample-process-assignment/configuration-intermediate-shelf-sample-process-assignment.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationIntermediateShelfSampleProcessAssignmentService {
    async create(laboratoryId: number, request: ConfigurationIntermediateShelfSampleProcessAssignmentCreateRequest): Promise<ConfigurationIntermediateShelfSampleProcessAssignmentResponse> {
        const response = await axios.post<ConfigurationIntermediateShelfSampleProcessAssignmentResponse>(`/configuration/laboratories/${laboratoryId}/intermediateShelfSampleProcessAssignment`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationIntermediateShelfSampleProcessAssignmentResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationIntermediateShelfSampleProcessAssignmentResponse>>(`/configuration/laboratories/${laboratoryId}/intermediateShelfSampleProcessAssignment`, { ...filterModel }, { params })
        return response.data
    }

    async get(intermediateShelfSampleProcessAssignmentId: number, laboratoryId: number): Promise<ConfigurationIntermediateShelfSampleProcessAssignmentResponse> {
        const response = await axios.get<ConfigurationIntermediateShelfSampleProcessAssignmentResponse>(`/configuration/laboratories/${laboratoryId}/intermediateShelfSampleProcessAssignment/${intermediateShelfSampleProcessAssignmentId}`)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/intermediateShelfSampleProcessAssignment/batch`, { data: request })
        return response.data
    }

    async patch(laboratoryId: number, request: ConfigurationIntermediateShelfSampleProcessAssignmentPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/intermediateShelfSampleProcessAssignment/batch`, request)
        return response.data
    }
}

export const configurationIntermediateShelfSampleProcessAssignmentService = new ConfigurationIntermediateShelfSampleProcessAssignmentService()
